<div *ngIf="showItemValidation(game?.underlyingRule.GameType, 'metric')">
    <div class="row row-flex mt-1">
        <div class="col-12 align-items-center justify-content-center">
            <div class="body-card-title card-flex">
                <span #metricText class="variation-ellipsis" [tooltip]="checkTextTruncation(game?.SelectedMetrics[0]?.abbrev, TooltipType.Q1)" 
                    placement="top" container="body" 
                    containerClass="tooltip-custom-multiplier"
                    (mouseenter)="tooltip.show()" 
                    triggers="manual"
                    #tooltip="bs-tooltip"
                    (mouseleave)="tooltip.hide()"
                    (wheel)="tooltip.hide()">
                    {{game?.SelectedMetrics[0]?.abbrev}}
                </span>:
                <span class="body-card-title-content add-content-flex ml-1">{{getMetricValue()}}</span>
            </div>
        </div>
    </div>
</div>
<cxone-game-qualifier *ngIf="game.Qualifier !== null" [game]="game" [ranking]="rankingData" [gameStatus]="gameStatus" [checkTextTruncation]="checkTextTruncation"></cxone-game-qualifier>
<div *ngIf="game?.underlyingRule.GameType === GameType.MultiplierMadness">            
    <div class="row mt-1">
        <div class="col-12 align-items-center mt-2 justify-content-center">
            <div class="body-card-title">
                {{getLocalizationString("Multiplier_title", "Multiplier")}}: <span class="body-card-title-content">{{cvNumberLocalizePipe.transform(game?.MultiplierMadnessRewards?.coins)}} {{getLocalizaCoins(game?.MultiplierMadnessRewards?.coins)}}</span>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="game?.MultiplierMadnessRewards?.maxCoinsPayout && game?.MultiplierMadnessRewards?.maxCoinsPayout > 0">
        <div class="col-12 align-items-center mt-1 justify-content-center">
            <div class="body-card-title">
                {{getLocalizationString("MaxPayout_title", "Max. Payout")}}: <span class="body-card-title-content"> {{cvNumberLocalizePipe.transform(game?.MultiplierMadnessRewards?.maxCoinsPayout)}} {{getLocalizaCoins(game?.MultiplierMadnessRewards?.maxCoinsPayout)}}</span>
            </div>
        </div>
    </div>
</div>